import { Environment } from '@ovh-ux/manager-config';
import { clientAuth } from '../plugin/auth/index.js';
import { clientNavigation } from '../plugin/navigation/index.js';
import { exposeTrackingAPI } from '../plugin/tracking/index.js';
import { clientLogger } from '../plugin/logger/index.js';
export default function exposeApi(shellClient) {
    const notifyHashChange = () => {
        if (window.parent !== window.self) {
            shellClient.invokePluginMethod({
                plugin: 'routing',
                method: 'onHashChange',
                args: [
                    {
                        hash: window.location.hash,
                        path: window.location.pathname,
                    },
                ],
            });
        }
    };
    return {
        environment: {
            getEnvironment: () => shellClient
                .invokePluginMethod({
                plugin: 'environment',
                method: 'getEnvironment',
            })
                .then((environment) => new Environment(environment)),
            setUniverse: (universe) => shellClient.invokePluginMethod({
                plugin: 'environment',
                method: 'setUniverse',
                args: [universe],
            }),
            setApplication: (applicationId) => shellClient.invokePluginMethod({
                plugin: 'environment',
                method: 'setApplication',
                args: [applicationId],
            }),
            setUser: (user) => shellClient.invokePluginMethod({
                plugin: 'environment',
                method: 'setUser',
                args: [user],
            }),
        },
        i18n: {
            getLocale: () => shellClient.invokePluginMethod({
                plugin: 'i18n',
                method: 'getLocale',
            }),
            onLocaleChange: (callback) => shellClient.addEventListener('i18n:locale-change', callback),
            setLocale: (locale) => shellClient.invokePluginMethod({
                plugin: 'i18n',
                method: 'setLocale',
                args: [locale],
            }),
            getAvailableLocales: () => shellClient
                .invokePluginMethod({
                plugin: 'i18n',
                method: 'getAvailableLocales',
            })
                .then((locales) => {
                return locales;
            }),
        },
        routing: {
            listenForHashChange: () => window.addEventListener('hashchange', notifyHashChange),
            stopListenForHashChange: () => window.removeEventListener('hashchange', notifyHashChange),
            onHashChange: notifyHashChange,
        },
        auth: clientAuth(shellClient),
        ux: {
            showAccountSidebar: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'showAccountSidebar',
            }),
            isAccountSidebarVisible: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'isAccountSidebarVisible',
            }),
            setForceAccountSiderBarDisplayOnLargeScreen: (isForced) => {
                shellClient.invokePluginMethod({
                    plugin: 'ux',
                    method: 'setForceAccountSiderBarDisplayOnLargeScreen',
                    args: [isForced],
                });
            },
            resetAccountSidebar: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'resetAccountSidebar',
            }),
            isMenuSidebarVisible: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'isMenuSidebarVisible',
            }),
            showMenuSidebar: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'showMenuSidebar',
            }),
            updateMenuSidebarItemLabel: (serviceName, label) => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'updateMenuSidebarItemLabel',
                args: [serviceName, label],
            }),
            onRequestClientSidebarOpen: (callback) => shellClient.addEventListener('ux:client-sidebar-open', callback),
            getSSOAuthModalMode: (oldUserCookie) => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'getSSOAuthModalMode',
                args: [oldUserCookie],
            }),
            getUserIdCookie: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'getUserIdCookie',
            }),
            openLiveChat: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'openLiveChat',
            }),
            closeChatbot: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'closeChatbot',
            }),
            isChatbotReduced: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'isChatbotReduced',
            }),
            isChatbotVisible: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'isChatbotVisible',
            }),
            startProgress: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'startProgress',
            }),
            stopProgress: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'stopProgress',
            }),
            hidePreloader: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'hidePreloader',
            }),
            showPreloader: () => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'showPreloader',
            }),
            notifyModalActionDone: (id) => shellClient.invokePluginMethod({
                plugin: 'ux',
                method: 'notifyModalActionDone',
                args: [id],
            }),
        },
        location: {
            getLocations: () => shellClient.invokePluginMethod({
                plugin: 'location',
                method: 'getLocations',
            }),
        },
        navigation: clientNavigation(shellClient),
        tracking: exposeTrackingAPI(shellClient),
        logger: clientLogger(shellClient),
    };
}
//# sourceMappingURL=api.js.map